module.exports = __webpack_public_path__ + "img/dropbox.267016f0.svg";